import React from 'react';
import { type Task, Checklist } from '@atlassiansox/checklist';
import { useIntl } from '@atlassian/jira-intl';
import { useRightSidebarController } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/right-sidebar-controller/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useActions, useOpenTaskId, useTasks } from '../services/index.tsx';
import { QUICKSTART_UI_STATUS_MINIMIZED, QUICKSTART_PANEL_ID } from '../services/constants.tsx';
import { OnboardingCheckListPostTasks } from './OnboardingCheckListPostTasks.tsx';

type TaskDictionary = Record<string, Omit<Task, 'completed'>>;

export const OnboardingCheckList = ({ taskDictionary }: { taskDictionary: TaskDictionary }) => {
	const { formatMessage } = useIntl();

	const tasks = useTasks();
	const openTaskId = useOpenTaskId();
	const { closeCurrentTask, setOpenTaskId, setQuickstartBannerVisibility } = useActions();
	const { closeRightSidebar } = useRightSidebarController();
	const accountId = useAccountId();

	if (!tasks) {
		return null;
	}

	const handleClose = () => {
		closeCurrentTask();
		setQuickstartBannerVisibility({ visibility: QUICKSTART_UI_STATUS_MINIMIZED, accountId });
		closeRightSidebar(QUICKSTART_PANEL_ID);
	};

	// TODO: POL-17792 handle the case where the task is not in the taskDictionary
	const tasksToRender = tasks.items.map((task) => {
		return {
			...taskDictionary[task.id],
			completed: task.completed,
		};
	});

	return (
		<Checklist
			tasks={tasksToRender}
			isOpen
			onClose={handleClose}
			title={formatMessage(tasks.title)}
			expandedTask={openTaskId ?? undefined}
			onTaskExpand={setOpenTaskId}
			postTasksComponent={<OnboardingCheckListPostTasks />}
		/>
	);
};
